import { render, staticRenderFns } from "./RecentUploadsList.vue?vue&type=template&id=3d0bafa0&scoped=true&"
import script from "./RecentUploadsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecentUploadsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecentUploadsList.vue?vue&type=style&index=0&id=3d0bafa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0bafa0",
  null
  
)

export default component.exports